import { Directive, HostListener, Input } from '@angular/core';
import { Coerce } from '@kalidea/kaligraphi';
import { LayoutNavigationExtra, LayoutRoute, LayoutService } from 'src/app/_core/services/layout.service';
import { SubscriptionManager } from 'src/app/_core/tools/subscription-manager';
import { take } from 'rxjs/operators';
import { ListingComponent } from 'src/app/_shared/components/listing/listing.component';

@Directive({
    selector: '[appNavigateBack]',
    standalone: false
})
export class NavigateBackDirective extends SubscriptionManager {

    @Coerce('boolean')
    @Input()
    keepFiltersParam: boolean;

    @Input() defaultRoute: [LayoutRoute, LayoutNavigationExtra] = null;

    @Input() overrideExtra: LayoutNavigationExtra = null;

    constructor(private layoutService: LayoutService) {
        super();
    }

    @HostListener('click')
    navigation(): void {
        let overrideExtra: LayoutNavigationExtra = null;

        if (this.overrideExtra) {
            overrideExtra = this.overrideExtra;
        } else if (this.keepFiltersParam) {
            overrideExtra = {queryParams: {[ListingComponent.keepFiltersParamName]: '1'}};
        }

        this.watch$ = this.layoutService.navigateBack(this.defaultRoute, overrideExtra).pipe(take(1));
    }

}
